import React, { ForwardedRef, forwardRef, useImperativeHandle, useRef } from "react"
import { TOverlayProps } from "./Overlay"
import FullscreenBackdrop from "./FullscreenBackdrop"
import AnchoredBackdrop from "./AnchoredBackdrop"
import { IBackdrop, TBackdropProps } from "./Backdrop"
import _ from "lodash"

export type TOverlayContainer = {
    id:string
    overlayId:string
    active:boolean
    dismissed:boolean               // dismissed by clicking backdrop
    overlayProps:TOverlayProps
}

export type TOverlayContainersProps = {
    containers:TOverlayContainer[]
    onDismissed:(id:string) => void
    onDismiss:() => void
}

export interface IOverlayContainers {
    onDown:(e:PointerEvent) => void
}

export default forwardRef( (props:TOverlayContainersProps, ref?:ForwardedRef<IOverlayContainers>) => {
    const backdrops = useRef<Record<string, IBackdrop>>({})

    const refCb = (id:string) => (backdrop:IBackdrop|null) => {
        if (backdrop) backdrops.current[id] = backdrop
        else delete backdrops.current[id]
    }

    const onDown = async (e:PointerEvent) => {
        for(var i=props.containers.length-1; i>=0; i--) {
            const container = props.containers[i], ref = backdrops.current[container.overlayId]
            if (container.active && ref && ref.onDown(e)) break;
        }    
    }

    useImperativeHandle(ref, () => ({onDown}))
    if (props.containers.length==0) return <></>
    else {
        const topFullscreen = _.findLast(props.containers, c => !c.overlayProps?.anchor && c.active)
        const overlays:JSX.Element[] = props.containers.map((container,i) => {
            const backdropProps : TBackdropProps&{key:string} = {
                id:container.id,
                overlayId:container.overlayId,
                index:i,
                active:container.active,
                onDismissed:props.onDismissed,
                onDismiss:props.onDismiss,
                key:container.overlayId,
                overlayProps:container.overlayProps
            }
            if (container.overlayProps?.anchor) return <AnchoredBackdrop {...backdropProps} ref={refCb(container.overlayId)}/>
            else return <FullscreenBackdrop isTop={container==topFullscreen} {...backdropProps} ref={refCb(container.overlayId)}/>
        })
        return <>{overlays}</>
    }
})
